import React from 'react';
import ReactDOM from 'react-dom';

import InfoWindowContent from '../components/info-window/info-window-content';

/**
 * Function to create content for a google.maps.InfoWindow instance
 * @param title string
 * @param description string
 * @param artist string
 * @returns HTMLDivElement
 */
const createInfoWindowContent = (
  title: string,
  year: string,
  artist: string
): HTMLDivElement => {
  const infoWindowContentNode = document.createElement('div');
  ReactDOM.render(
    <InfoWindowContent
      title={title}
      year={year}
      artist={artist}
    />,
    infoWindowContentNode
  );

  return infoWindowContentNode;
};
export default createInfoWindowContent;
